import $ from 'jquery';
import LP from '../0-lp';

LP.UI.DataTable = {
  init: function (tableId, useRowGroups) {
    // only initialize if not yet initializes
    var $table = $('#' + tableId);
    var $block = $table.closest('.lp-compare-view');
    if ($.fn.DataTable.isDataTable($table)) return true;

    var orderCellsTop = false;
    if ($table.find('.colTexts').length > 0 && $table.find('.colVars').length > 0) {
      orderCellsTop = true;
    }
    var tableOptions = {
      orderCellsTop: orderCellsTop,
      orderFixed: [0, 'asc'], // Fixed ordering on the group, so that ordering doesn't rip the groups apart
      // order: [1, 'asc'],

      columnDefs: [
        {
          orderable: false,
          targets: 0,
        },
      ],
    };

    if (useRowGroups) {
      tableOptions.rowGroup = {
        dataSrc: 0, // ID of the column that specifies the groups
        startRender: function (rows, group) {
          // The function that renders the group headers
          var data = rows.table().data().toArray(); // get all data
          var $cols = rows.columns().header().to$(); // get the columns and turn them into jquery-objects

          // go through all data to count the groups
          var groups = [];
          for (var i = 0; i < data.length; i++) groups[data[i][0]] = true;

          // check if this is the first group, then we can leave the header almost empty
          var firstGroup = true;
          /*rows.every(function () {
                        // since jquery-datatables always set indexes internally, there will always be a row with index 0
                        if (this.index() === 0) { firstGroup = true; return false; }
                    });*/

          if (firstGroup) {
            return $('<tr><th role="rowgroup" colspan="' + ($cols.length - 1) + '">' + group + '</th></tr>');
          }

          if (Object.keys(groups).length <= 1) {
            // Check if we have only one group, then we can just ignore it
            return $('<tr style="display: none"></tr>');
          }

          // Build the html for the header
          var html = '';
          $cols.each(function (key, col) {
            // go through each column
            var $element = $(col).clone();
            $element.removeAttr('rowspan'); // cleanup

            if (key === 0) {
              $element.html(group);
            }

            html += $element.wrap('<div>').parent().html(); // workaround to get the full html of the element
          });
          html = '<tr>' + html + '</tr>';
          return $(html);
        },
      };
    }
    $table.DataTable(tableOptions);

    var val_1_toggle = $('.val_c.toggle', $block);
    if (val_1_toggle.length > 0) LP.UI.DataTable.toggleValues(tableId, 'val_c', $('input', val_1_toggle).is(':checked'));

    var val_2_toggle = $('.val_g.toggle', $block);
    if (val_2_toggle.length > 0) LP.UI.DataTable.toggleValues(tableId, 'val_g', $('input', val_2_toggle).is(':checked'));

    var val_3_toggle = $('.val_t.toggle', $block);
    if (val_3_toggle.length > 0) LP.UI.DataTable.toggleValues(tableId, 'val_t', $('input', val_3_toggle).is(':checked'));
  },

  toggleValues: function (tableId, valueClass, state) {
    var $table = $('#' + tableId);
    var $body = $('tbody', $table);
    var $head = $('thead', $table);
    var $foot = $('tfoot', $table);

    if (state == null) {
      $('td .' + valueClass, $body).toggleClass('hide'); // toogle items in data-cells
      $('th .' + valueClass, $foot).toggleClass('hide'); // toggle items in footer-cells

      $('th.' + valueClass, $table).toggleClass('hide'); // toggle columns in table
      $('td.' + valueClass, $table).toggleClass('hide'); // toggle columns in table
    } else if (state === true) {
      $('td .' + valueClass, $body).removeClass('hide'); // show items in data-cells
      $('th .' + valueClass, $head).removeClass('hide'); // show items in fotter-cells

      $('th.' + valueClass, $table).removeClass('hide'); // show columns in table
      $('td.' + valueClass, $table).removeClass('hide'); // show columns in table
    } else if (state === false) {
      $('td .' + valueClass, $body).addClass('hide'); // hide items in data-cells
      $('th .' + valueClass, $foot).addClass('hide'); // hide items in footer-cells

      $('th.' + valueClass, $table).addClass('hide'); // hide columns in table
      $('td.' + valueClass, $table).addClass('hide'); // hide columns in table
    }
  },
};
